import generateId from 'lib/generateId';
import messagePayload from './messagePayload';

export default class SmoochIntegrationDouble {
  constructor() {
    this.onCallbacks = {};
    this.messages = [];
  }

  login() {
    return {
      then: (onSuccess, onErr) => {
        this.onSuccess = onSuccess;
        this.onErr = onErr;

        onSuccess();
      },
    };
  }

  setDelegate() {}

  on(key, fn) {
    this.onCallbacks[key] = fn;
  }

  getUser() {
    return { _id: 'some-smooch-user-id' };
  }

  updateUser({ appId, gladlyCustomerId }) {
    this.appId = appId;
    this.gladlyCustomerId = gladlyCustomerId;

    return new Promise(resolve => {
      resolve();
    });
  }

  getConversation() {
    if (this.messages.length == 0) {
      return { _id: undefined, messages: this.messages };
    }
    return { _id: 'conversation_id', messages: this.messages };
  }

  sendMessage(payload) {
    this.messages.push(payload);
    this.onCallbacks['message:sent'](messagePayload(this.getUser(), payload));
    payload.metadata.internalId = generateId();
    payload.role = 'appMaker';
    if (payload.text.toUpperCase() === 'END CHAT') {
      payload.metadata = {
        subType: 'SESSION_END',
      };
      payload.text = 'AGENT_ENDED';
    }
    this.onCallbacks['message:received'](messagePayload('appMaker', payload));
  }

  startTyping() {}

  stopTyping() {}

  render() {}

  init() {
    return {
      then: function(callback) {
        // delay necessary for integration tests
        setTimeout(callback, 1000);
      },
    };
  }
}
